<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<a id="title5"></a>
<div class="tp-title"><strong class="b">The Light Within Us</strong></div>
<div class="tp-author"><strong class="b">Albert Schweitzer</strong></div>
<div class="illustype_image"><div class="image"><img alt="e9780806537191_i0001.jpg" src="e9780806537191_i0001.jpg"/></div></div>
<div class="p-c">PHILOSOPHICAL LIBRARY</div>
<div class="p-c"><em class="i">New York</em></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537191_tp01.vue?58399162